import apiClient from "@/common/gateway-api";
import * as Actions from "@/store/actions.type";
import * as Mutations from "@/store/mutations.type";

export default {
  // Parameters:
  // -----------
  // commit
  //
  // Returns
  // -----------
  // Clears the Error to the State
  [Actions.CLEAR_PRODUCT_ERRORS]({ commit }) {
    commit(Mutations.SET_AWS_ERROR, null);
  },
  // Parameters:
  // -----------
  // commit
  // search
  //
  // Returns
  // -----------
  // Sets the Search in the MultiSelect to the State
  async [Actions.AWS_SEARCH_MULTISELECT_PRODUCTS](
    { commit },
    { search, region }
  ) {
    let result = [];
    if (search) {
      try {
        let response = await apiClient.get(
          "/api/v1/tyche/wooproducts/search/advanced",
          {
            params: {
              itemsPerPage: 10,
              page: 1,
              keyword: search,
              region
            }
          }
        );
        result = response.data.data;
      } catch (err) {
        console.log(err);
      }
    }
    commit(Mutations.SET_AWS_SEARCH_MULTISELECT, result);
  }
};
